import { createApp } from 'vue'
import PracticeSession from '../components/PracticeSession.vue'

export function mountReview() {
  const el = document.getElementById('review-app')
  if (!el) return

  const app = createApp(PracticeSession, {
    level: parseInt(el.dataset.level),
    exerciseUrl: el.dataset.exerciseUrl,
    backUrl: el.dataset.backUrl,
    subscribed: el.dataset.subscribed === 'true',
    reviewMode: true,
  })
  app.mount(el)
}
